<div class="flex items-center space-x-4">
    <button (click)="decrement()" class="px-4 py-2 bg-red-500 text-white rounded-lg">-</button>
    <span class="text-2xl">{{ count }}</span>
    <button (click)="increment()" class="px-4 py-2 bg-green-500 text-white rounded-lg">+</button>
  </div>
  